'use client'

import { useState, useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/navigation'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'
import { Eyebrow } from '@/components/ui/eyebrow'
import { Button } from '@/components/ui/button'
import { Text } from '@/components/ui/text'

export function CtaBand() {
  const t = useTranslations('home.ctaBand')
  const words = t.raw('words') as string[]

  const [index, setIndex] = useState(0)
  const [phase, setPhase] = useState<'in' | 'out'>('in')

  useEffect(() => {
    const interval = setInterval(() => {
      setPhase('out')
      setTimeout(() => {
        setIndex((i) => (i + 1) % words.length)
        setPhase('in')
      }, 350)
    }, 2500)
    return () => clearInterval(interval)
  }, [words.length])

  return (
    <Section tone="off" spacing="lg">
      <Container>
        <div className="flex flex-col items-center gap-10 text-center">
          <div className="flex flex-col items-center gap-5 max-w-[900px] mx-auto">
            <Eyebrow>{t('eyebrow')}</Eyebrow>
            <h2 className="font-display text-text-primary text-[clamp(2.4rem,6vw,4.8rem)] font-extrabold tracking-[-0.03em]">
              {t('headline')}
              <br />
              <span
                key={index}
                className="grad-text inline-block"
                style={{
                  animation: `${phase === 'in' ? 'word-in' : 'word-out'} 0.35s ease forwards`,
                }}
              >
                {words[index]}
              </span>
            </h2>
            <Text size="lg" tone="muted" className="max-w-3xl mx-auto text-center">
              {t('subtitle')}
            </Text>
          </div>
          <Button asChild variant="primary" size="lg">
            <Link href="#contact">{t('cta')}</Link>
          </Button>
        </div>
      </Container>
    </Section>
  )
}
